import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import {
  CLEAR_RESTORE_DATA,
  HANDLE_RESTORE_ROUTE_FAILED,
  HANDLE_RESTORE_ROUTE_SUCCESS,
  RESTORE_ACCOUNT_EMAIL,
  RESTORE_ACCOUNT_EMAIL_FAILED,
  RESTORE_ACCOUNT_EMAIL_SUCCESS,
  RESTORE_ACCOUNT_PASSWORD,
  RESTORE_ACCOUNT_PASSWORD_FAILED,
  RESTORE_ACCOUNT_PASSWORD_SUCCESS,
} from '../constants';
import { RestoreAccountMetaDataType, RestoreAccountType } from '../../types/stateTypes';

const defaultMetaData: RestoreAccountMetaDataType = {
  authSessionId: '',
  clientId: '',
  key: '',
  tabId: '',
};

export const initialState: RestoreAccountType = {
  errorText: '',
  isMailSent: false,
  loading: false,
  metaData: defaultMetaData,
  success: false,
};

export default (
  state = initialState,
  action: ActionType<RestoreAccountType | PayloadErrorType>
): RestoreAccountType => {
  switch (action.type) {
    case CLEAR_RESTORE_DATA: {
      return { ...initialState };
    }
    case HANDLE_RESTORE_ROUTE_FAILED: {
      const { message } = action.payload as PayloadErrorType;
      return {
        ...state,
        errorText: message,
        metaData: defaultMetaData,
      };
    }
    case HANDLE_RESTORE_ROUTE_SUCCESS: {
      const { metaData } = action.payload as RestoreAccountType;
      return { ...state, metaData: { ...metaData } };
    }
    case RESTORE_ACCOUNT_EMAIL: {
      return { ...state, loading: true };
    }
    case RESTORE_ACCOUNT_EMAIL_FAILED: {
      const { message } = action.payload as PayloadErrorType;
      return { ...state, errorText: message, loading: false };
    }
    case RESTORE_ACCOUNT_EMAIL_SUCCESS: {
      return { ...state, errorText: '', isMailSent: true, loading: false };
    }
    case RESTORE_ACCOUNT_PASSWORD: {
      return { ...state, isMailSent: false, loading: true };
    }
    case RESTORE_ACCOUNT_PASSWORD_FAILED: {
      const { message } = action.payload as PayloadErrorType;
      return { ...state, errorText: message, loading: false };
    }
    case RESTORE_ACCOUNT_PASSWORD_SUCCESS: {
      return { ...state, loading: false, success: true };
    }

    default: {
      return state;
    }
  }
};
